import {
  injectSlice,
  createAsyncThunk,
  createSelector,
  createSlice,
  createAction,
} from '@bonanza-social/toolkit/state';
import ShopService from '../services/ShopService/ShopService';
import { SalesState, ShopSaleType } from './sales.types';

export const fetchShopSales = createAction('shopSales/fetch');

export const getShopSales = createAsyncThunk(
  'shopSales/get',
  async () => await ShopService.getSales(),
);

const initialState: SalesState = {
  dataState: 'idle',
  data: undefined,
  systemTimeDifference: 0,
};

const sales = createSlice({
  name: 'sales',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getShopSales.pending, (state) => {
      state.dataState =
        state.dataState === 'fulfilled' ? 'refreshing' : 'pending';
    });

    builder.addCase(getShopSales.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(getShopSales.fulfilled, (state, action) => {
      const { sales, systemTime } = action.payload;

      state.data = sales;
      state.systemTimeDifference = new Date(systemTime).getTime() - Date.now();
      state.dataState = 'fulfilled';
    });
  },
});

export const withSales = injectSlice({
  reducerPath: 'sales',
  reducer: sales.reducer,
});

export const selectSales = withSales.selector((state) => state.sales.data);

export const selectSaleById = createSelector(
  [selectSales, (_, saleId: ShopSaleType['id']) => saleId],
  (sales, saleId) => sales?.find((item) => item.id === saleId),
);

export const selectSalesDataState = withSales.selector(
  (state) => state.sales.dataState,
);

export const selectSalesSystemTimeDifference = withSales.selector(
  (state) => state.sales.systemTimeDifference,
);

declare global {
  interface LazyLoadedSlices {
    sales: ReturnType<typeof sales.reducer>;
  }
}
